export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11804.6929ff52.jpg";